import { render, staticRenderFns } from "./CreateTenantCustomer.vue?vue&type=template&id=0f129aec&"
import script from "./CreateTenantCustomer.vue?vue&type=script&lang=js&"
export * from "./CreateTenantCustomer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports